import { authenticationOpaPermissionsAtom } from '../';
import { store } from '../../store';

export const authenticationBridge = {
  mePermissions: {
    failure: (error: Error): void => {
      store.set(authenticationOpaPermissionsAtom, (prev) => ({
        ...prev,
        error,
        isFetching: false,
      }));
    },
    request: (): void => {
      store.set(authenticationOpaPermissionsAtom, (prev) => ({
        ...prev,
        error: null,
        isFetching: true,
      }));
    },
    success: (data: string[]): void => {
      store.set(authenticationOpaPermissionsAtom, {
        data,
        error: null,
        isFetching: false,
      });
    },
  },
};
